import { createFileRoute, redirect } from '@tanstack/react-router'

import { ACCOUNT_PATHS } from '@/features/user/profile'

/**
 * Rota legada. Mantida como redirect porque há links fora do controle do app —
 * e-mails transacionais e deep links construídos pelo WebView nativo contra os
 * paths flat do evento.
 */
export const Route = createFileRoute('/_event/meu-perfil')({
  beforeLoad: () => {
    throw redirect({
      to: ACCOUNT_PATHS.profile,
      replace: true
    })
  }
})
